import ConnectedTokenList from './Container';

export default ConnectedTokenList;
